// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

var loading_icon = '<svg width="42" height="42" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="loading_icon" style="background: none;"><circle cx="50" cy="50" fill="none" stroke="#03417d" stroke-width="8" r="35" stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(215.934 50 50)"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform></circle></svg>';

jQuery(window).on('load', function() {
	jQuery('html').removeClass('preload');
});


// Throttle function: Input as function which needs to be throttled and delay is the time interval in milliseconds
var timerId;
var throttleFunction = function (func, delay) {
	// If setTimeout is already scheduled, no need to do anything
	if (timerId) {
		return
	}

	// Schedule a setTimeout after delay seconds
	timerId = setTimeout(function () {
		func()

		// Once setTimeout function execution is finished, timerId = undefined so that in <br>
		// the next scroll event function execution can be scheduled by the setTimeout
		timerId = undefined;
	}, delay)
}

function toggle_head_classes() {
	if (jQuery(this).scrollTop() > 50) {
		jQuery('.head').addClass('sticky');
	} else {
		if (!(jQuery('body').hasClass('single-product') || jQuery('body').hasClass('category') || jQuery('body').hasClass('single-post') || jQuery('body').hasClass('blog') || jQuery('body').hasClass('page-template-page-contact') || jQuery('body').hasClass('page-template-page-full') || jQuery('body').hasClass('error404'))){
			jQuery('.head').removeClass('sticky');
		}
	}
}


// Highlight closest .navi_content__item to top (but not above)
function highlightClosestNaviItem() {
	var closest = null;
	var closestTop = Infinity;
	jQuery('.navi_content__item').each(function() {
		var rect = this.getBoundingClientRect();
		if (rect.top >= 80 && rect.top < closestTop) {
			closestTop = rect.top;
			closest = this;
		}
	});
	jQuery('.navi_content__nav ul li a').removeClass('active');
	if (closest) {
		var id = jQuery(closest).attr('id');
		if (id) {
			jQuery('.navi_content__nav ul li a[href="#' + id + '"]').addClass('active');
		}
	}
}



jQuery(document).ready(function() {

	var width = jQuery(window).width();

	toggle_head_classes(); // Run on page load so if refreshing and further down page the header will look right
	jQuery(window).scroll(function() {
		throttleFunction(function() {
			toggle_head_classes();
			if (jQuery('.navi_content__item').length > 0) {
				highlightClosestNaviItem();
			}
		}, 80);
	});

	function resiNav() {
		jQuery( ".menu" ).before( "<figure></figure>" );
		//jQuery('.sub-menu').prepend('<li class="current_parent"><p></p></li>');

		// var parents = jQuery('.menu-item-has-children');
		// for (var i = 0; i < parents.length; i++) {
		// 	var parentTitle = parents[i].children[0].text;
		// 	var previousParentTitle = parents[i].children[1].children[0].children[0];
		// 	previousParentTitle.innerText = parentTitle;
		// }

		jQuery('.menu-header .menu-item-has-children > a').click(function (e) {
			// if (jQuery(window).width() < 920) {
			// 	e.preventDefault();
			// }
			// console.log(jQuery(this)[0].text);
			jQuery(this).parent().toggleClass('open');
			jQuery(this).next('ul.sub-menu').toggleClass('open');
		});

		jQuery('li.current_parent').click(function() {
			jQuery(this).parent().toggleClass('open');
		});

		jQuery('.resi_button, .resi_over, .menu-header figure').click(function() {
			jQuery('html').toggleClass('js-nav');
			jQuery('ul.sub-menu').removeClass('open')
		});

	}
	resiNav();

	jQuery('*[data-scroll]').click(function(e) {
		e.preventDefault();
		var target = jQuery(this).data('scroll');

		jQuery('html, body').animate({
			 scrollTop: jQuery(target).offset().top - 80
		}, 300);
	});

	jQuery('.full_sections__more .home_banner__more').click(function(e) {
		e.preventDefault();
		var target = jQuery(this).parent().parent().parent().next();
		jQuery('html, body').animate({
			scrollTop: jQuery(target).offset().top
		}, 300);
	});


	// Remove error message form CF7 when input is clicked
	if (jQuery('.wpcf7').length > 0) {
		jQuery('.wpcf7 input, .wpcf7 teaxtarea, .wpcf7 select').click(function(){
			jQuery(this).next('.wpcf7-not-valid-tip').remove();
		});
	}

	if (WPURLS.ajaxurl) {



	}

	jQuery('.product__tab__trigger').click(function() {
		jQuery(this).parent().toggleClass('active');
	});

	const swiper = new Swiper('.testimonials:not(.testimonials--full) .swiper', {
		loop: true,
		pagination: {
			el: '.swiper-pagination',
		},
		autoplay: {
			delay: 3000,
		},
		
	});

	const swiperFull = new Swiper('.testimonials--full .swiper', {
		loop: true,
		pagination: {
			el: '.swiper-pagination',
		},
		autoplay: {
			delay: 3000,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		autoHeight: true,
	});

	swiperFull.on('slideChange', function () {
		jQuery('.testimonials--full .swiper-pagination-number').text(swiperFull.realIndex + 1 + ' of ' + swiperFull.slides.length);
	});


	const screw = new Swiper('.screw_slider', {
		loop: true,
		pagination: {
			el: '.swiper-pagination',
		},
		// Navigation arrows
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});


	jQuery('.system_tabs__triggers').easytabs({
		panelContext: jQuery('.system_tabs__content'),
		updateHash: false,
		animationSpeed: 0
	});

	jQuery('.screw_slide__graphic__tooltips div .trigger').click(function () {
		if (jQuery(this).parent().hasClass('active')){
			jQuery('.screw_slide__graphic__tooltips div').removeClass('active');
		} else {
			jQuery('.screw_slide__graphic__tooltips div').removeClass('active');
			jQuery(this).parent().addClass('active');
		}
	});


    // Single product slider
    if(jQuery('.product_thumbs.swiper-container').length > 0) {
		var prodsliderThumbs = new Swiper('.product_thumbs.swiper-container', {
			slidesPerView: 3,
			spaceBetween: 9,
			watchSlidesProgress: true,
			allowTouchMove: false,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			breakpoints: {
				700: {
					slidesPerView: 4,
					spaceBetween: 9,
				}
			},
		});
	}
	jQuery('.product_gallery.swiper-container .woocommerce-product-gallery__image').addClass('swiper-slide');
    jQuery('.product_gallery.swiper-container .woocommerce-product-gallery__image > a').append('<span class="woocommerce-product-gallery__mag"></span>');
	var prodslider = new Swiper('.product_gallery.swiper-container', {
		slidesPerView: 1,
        spaceBetween: 10,
		autoHeight: true,
		thumbs: {
			swiper: prodsliderThumbs,
		},
        // pagination: {
        //     el: '.swiper-pagination--product_gallery',
        //     type: 'bullets',
        //     clickable: true,
        // },
	});
    prodslider.on('activeIndexChange', function () {
        prodslider.updateAutoHeight();
    });

	jQuery('.faqs__item-trigger').click(function() {
		jQuery(this).parent().toggleClass('active');
	});

	jQuery('.navi_content__nav ul li a').click(function(e) {
		e.preventDefault();
		var target = jQuery(this).attr('href');
		jQuery('html, body').animate({
			scrollTop: jQuery(target).offset().top - 110
		}, 300);
	});

	jQuery('.navi_content__nav ul').stick_in_parent({offset_top: 110});

	document.addEventListener( 'wpcf7mailsent', function( event ) {
		console.log(event);
	}, false );

	// if ( jQuery('body').hasClass('blog') ) {
	// 	jQuery("#recent-sticky").stick_in_parent({offset_top: 40});
	// }


	// Sliding banner text
	const popular_blogs = new Swiper('.popular_blogs', {
		speed: 1000,
		slidesPerView: 1,
		slidesPerGroup: 1,
		spaceBetween: 30,
		autoplay: {
			enabled: false,
		},
		allowTouchMove: true,
		loop: true,
		autoHeight: true,
		pagination: {
			el: ".swiper-pagination",
			type: "fraction",
			renderFraction: function (currentClass, totalClass) {
				return '<span class="' + currentClass + '"></span>' +
						' of ' +
						'<span class="' + totalClass + '"></span>';
			}
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		breakpoints: {
			1200: {
				slidesPerView: 3,
				slidesPerGroup: 3,
				autoHeight: false,
				autoplay: {
					enabled: true,
					delay: 5000,
				},
			},
			600: {
				slidesPerView: 2,
				slidesPerGroup: 2,
				autoHeight: false,
				autoplay: {
					enabled: true,
					delay: 5000,
				},
			},
		}
	});


});

